import React from 'react';
import { ChevronRight, RefreshCw } from 'lucide-react';
import { Avatar } from './Avatar';
import { StatusPill } from './StatusPill';
import { CategoryPill } from './CategoryPill';
interface Subscription {
  id: string;
  service: string;
  serviceColor: string;
  serviceInitial: string;
  hasAutoRenew?: boolean;
  member: string;
  memberColor: string;
  memberIndicator?: 'online' | 'offline' | 'away';
  category: 'utilities' | 'entertainment' | 'productivity' | 'design';
  categoryLabel: string;
  amount: string;
  billing: string;
  nextBilling: string;
  status: 'active' | 'paused' | 'cancelled';
}
const subscriptions: Subscription[] = [{
  id: '1',
  service: 'Grammarly',
  serviceColor: '#14b8a6',
  serviceInitial: 'G',
  hasAutoRenew: true,
  member: 'Vu',
  memberColor: '#f59e0b',
  memberIndicator: 'away',
  category: 'utilities',
  categoryLabel: 'Utilities',
  amount: '$30.00',
  billing: 'Monthly',
  nextBilling: 'in 10 days',
  status: 'active'
}, {
  id: '2',
  service: 'Claude',
  serviceColor: '#f97316',
  serviceInitial: '✦',
  member: 'Vu',
  memberColor: '#f59e0b',
  memberIndicator: 'away',
  category: 'entertainment',
  categoryLabel: 'Entertainment',
  amount: '$200.00',
  billing: 'Monthly',
  nextBilling: 'in 16 days',
  status: 'active'
}, {
  id: '3',
  service: 'ChatGPT Plus',
  serviceColor: '#000000',
  serviceInitial: '◆',
  member: 'Vu',
  memberColor: '#f59e0b',
  memberIndicator: 'away',
  category: 'entertainment',
  categoryLabel: 'Entertainment',
  amount: '$20.00',
  billing: 'Monthly',
  nextBilling: 'in 22 days',
  status: 'active'
}];
export function SubscriptionTable() {
  return <div className="bg-[#1a1a1a] rounded-b-xl border border-[#252525] border-t-0 overflow-hidden" data-id="element-77">
      <table className="w-full" data-id="element-78">
        <thead data-id="element-79">
          <tr className="border-b border-[#2a2a2a]" data-id="element-80">
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider w-8" data-id="element-81">
              <input type="checkbox" className="rounded border-gray-600 bg-transparent" data-id="element-82" />
            </th>
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-83">
              Service
            </th>
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-84">
              Family Member
            </th>
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-85">
              Category
            </th>
            <th className="text-right px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-86">
              Amount
            </th>
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-87">
              Next Billing
            </th>
            <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-88">
              Status
            </th>
          </tr>
        </thead>
        <tbody data-id="element-89">
          {subscriptions.map(sub => <tr key={sub.id} className="border-b border-[#252525] hover:bg-[#202020] transition-colors duration-150 group" data-id="element-90">
              <td className="px-6 py-5" data-id="element-91">
                <div className="flex items-center gap-3" data-id="element-92">
                  <ChevronRight size={16} className="text-gray-600 group-hover:text-gray-400 transition-colors" data-id="element-93" />
                  <input type="checkbox" className="rounded border-gray-600 bg-transparent" data-id="element-94" />
                </div>
              </td>
              <td className="px-6 py-5" data-id="element-95">
                <div className="flex items-center gap-3" data-id="element-96">
                  <Avatar text={sub.serviceInitial} color={sub.serviceColor} size="md" data-id="element-97" />
                  <div className="flex items-center gap-2" data-id="element-98">
                    <span className="text-white font-medium" data-id="element-99">
                      {sub.service}
                    </span>
                    {sub.hasAutoRenew && <RefreshCw size={14} className="text-green-500" data-id="element-100" />}
                  </div>
                </div>
              </td>
              <td className="px-6 py-5" data-id="element-101">
                <Avatar text={sub.member} color={sub.memberColor} indicator={sub.memberIndicator} size="sm" data-id="element-102" />
              </td>
              <td className="px-6 py-5" data-id="element-103">
                <CategoryPill category={sub.category} data-id="element-104">
                  {sub.categoryLabel}
                </CategoryPill>
              </td>
              <td className="px-6 py-5 text-right" data-id="element-105">
                <div className="text-white font-semibold" data-id="element-106">{sub.amount}</div>
                <div className="text-xs text-gray-600" data-id="element-107">{sub.billing}</div>
              </td>
              <td className="px-6 py-5" data-id="element-108">
                <span className="text-gray-400 text-sm" data-id="element-109">{sub.nextBilling}</span>
              </td>
              <td className="px-6 py-5" data-id="element-110">
                <StatusPill status={sub.status} data-id="element-111">Active</StatusPill>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}